/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Header from './header';
import Row from './row';
import { fieldsPropTypes, dataPropTypes, errorsPropTypes } from './propTypes';
import TableContainer from '../../../../../newEditor/tablePart/tableContainer';
import TableHeader from '../../../../../newEditor/tablePart/tableHeader';
import TPCommandPanel from '../../../../../newEditor/commandPanels/tablepart';
import TableRow from '../../../../../newEditor/tablePart/tablerow';
import Placeholder from '../../../../../newEditor/tablePart/placeholder';
import useTablePart from '../../../../../newEditor/hook/tablepart';
import { foreignPropType } from '../../../../../../constants/backend/propTypes';

function Equpmanet({
  onChange, data, fields, errors, readOnlyFields, readOnly,
}) {
  const tableName = 'aktdvkequpmanetrow_set';
  const {
    tableData, tableActions, pinHeader, showFooter,
    tableContainerRef, tableReadOnlyFields, tableErrors,
    tableFields, activeCol, activeRow, highlights, pinAllowed,
  } = useTablePart({
    data, onChange, tableName: 'aktdvkequpmanetrow_set', readOnlyFields, errors, fields,
  });

  return (
    <TableContainer
      pinHeader={pinHeader}
      pinAllowed={pinAllowed}
      onAllowPin={tableActions.onAllowPin}
    >
      <TableHeader pinHeader={pinHeader} pinAllowed={pinAllowed}>
        <TPCommandPanel
          pinHeader={pinHeader}
          pinAllowed={pinAllowed}
          tableActions={tableActions}
          showFooter={showFooter}
          readOnly={readOnly}
          activeRow={activeRow}
        />
        <Header
          fields={tableFields}
          activeCol={activeCol}
          highlights={highlights}
          onToggleHighlight={tableActions.onToggleHighlightColumn}
        />
      </TableHeader>
      <Card.Body className="p-0" ref={tableContainerRef}>
        {tableData && tableData.map((row, index) => (
          <TableRow
            key={index}
            rowIndex={index}
            active={activeRow === index}
            activeCol={activeCol}
            tableName={tableName}
            onMoveRow={tableActions.onMoveRow}
          >
            <Row
              rowIndex={index}
              row={row}
              onChange={tableActions.onCellChange}
              active={activeRow === index}
              readOnly={readOnly}
              highlights={highlights}
              fields={tableFields}
              errors={tableErrors[index]}
              readOnlyFields={tableReadOnlyFields}
            />
          </TableRow>
        ))}
        <Placeholder onFocus={() => tableActions.onAddRow()} />
      </Card.Body>
    </TableContainer>
  );
}

Equpmanet.propTypes = {
  data: PropTypes.shape({
    type_land_use: foreignPropType,
    aktdvkequpmanetrow_set: PropTypes.arrayOf(PropTypes.shape(dataPropTypes)),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  fields: PropTypes.shape({
    aktdvkequpmanetrow_set: fieldsPropTypes,
  }).isRequired,
  errors: PropTypes.shape({
    aktdvkequpmanetrow_set: PropTypes.arrayOf(errorsPropTypes),
  }),
  readOnlyFields: PropTypes.shape({
    aktdvkequpmanetrow_set: PropTypes.arrayOf(PropTypes.string),
  }),
  readOnly: PropTypes.bool,
};

Equpmanet.defaultProps = {
  errors: null,
  readOnlyFields: [],
  readOnly: false,
};

export default Equpmanet;
